const { createStructuredSelector } = require('reselect');
const { isAnonymousSelector } = require('viewModel/selectors/user/isAnonymousSelector');
const isInitializedSelector = require('selectors/user/isInitializedSelector');
const profileIdSelector = require('selectors/user/profileIdSelector');
const beautyInsiderAccountIdSelector = require('selectors/user/beautyInsiderAccount/biIdSelector');
const { firstNameSelector } = require('viewModel/selectors/user/firstNameSelector');
const { isSDUFeatureDownSelector } = require('viewModel/selectors/user/isSDUFeatureDownSelector');
const { preferredZipCodeSelector } = require('selectors/user/preferredZipCodeSelector');

const coreUserDataSelector = createStructuredSelector({
    isAnonymous: isAnonymousSelector,
    isInitialized: isInitializedSelector,
    userId: profileIdSelector,
    biId: beautyInsiderAccountIdSelector,
    firstName: firstNameSelector,
    isSDUFeatureDown: isSDUFeatureDownSelector,
    preferredZipCode: preferredZipCodeSelector
});

module.exports = { coreUserDataSelector };
